export default __webpack_public_path__ + "static/media/61.7287fb0a.jpg";